import { allProducts } from '@/data/products';

export interface ProductCategoryCount {
  name: string;
  count: number;
  slug: string;
}

export const slugifyCategory = (category: string): string =>
  category
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

// Legacy hash aliases kept so existing footer/links keep working
const LEGACY_HASH_TO_CATEGORY: Record<string, string> = {
  ecommerce: 'Retail & Fashion',
  crm: 'Customer Success & CRM',
  productivity: 'Productivity & Collaboration',
  finance: 'Financial & Business Intelligence',
  webapp: 'Core Applications',
  industry: 'Industry Verticals',
  marketing: 'Marketing & Sales',
  lms: 'Education & Training',
  voice: 'BPO & Contact Centre',
  competitors: 'Intelligence & Analytics',
  recruitment: 'Recruitment',
  hr: 'Human Resources',
  ticketing: 'IT & Support',
  centurion: 'Core Applications',
  blockchain: 'Emerging Technologies',
  'beauty-fashion': 'Retail & Fashion',
};

export const getProductCategoryCounts = (): ProductCategoryCount[] => {
  const counts = new Map<string, number>();

  allProducts.forEach((product) => {
    const productCategories = new Set<string>();
    if (product.category) productCategories.add(product.category);
    (product.categories || []).forEach((category: string) => productCategories.add(category));

    productCategories.forEach((category) => {
      counts.set(category, (counts.get(category) || 0) + 1);
    });
  });

  return Array.from(counts.entries())
    .map(([name, count]) => ({ name, count, slug: slugifyCategory(name) }))
    .sort((a, b) => a.name.localeCompare(b.name));
};

export const resolveHashToCategory = (hash: string): string | null => {
  const key = hash.replace(/^#/, '').toLowerCase();
  if (!key) return null;
  if (LEGACY_HASH_TO_CATEGORY[key]) return LEGACY_HASH_TO_CATEGORY[key];

  for (const category of getProductCategoryCounts()) {
    if (category.slug === key) return category.name;
  }
  return null;
};
